export const PLATFORM_BASE_URL = "https://platform.metal.com";
export const USER_CENTER_BASE_URL = "https://user.metal.com";
// smm cookie 默认 key
export const COOKIE_DEFAULT_KEY = "SMM_auth_token";
// 临时 token cookie 默认 key
export const COOKIE_TEMPORARY_KEY = "SMM_temporary_auth_token";
export const COOKIE_DOMAIN = ".metal.com";
export const RECAPTCHA_ENTERPRISE_SITEKEY = "6LduIootAAAAAJaPlHLQIjSqhOSITNjMQhUqymcj";
export const SUPPORTED_LOCALES = ["en", "es", "fr", "id", "ko", "pt", "ru", "th", "vn"];
export const DEFAULT_CONFIG = {
    apiBaseUrl: PLATFORM_BASE_URL,
    userCenterUrl: USER_CENTER_BASE_URL,
    cookieName: COOKIE_DEFAULT_KEY,
    temporaryCookieName: COOKIE_TEMPORARY_KEY,
    cookieDomain: COOKIE_DOMAIN,
    useRequestIdleCallback: false,
};
export const SIGN_IN_EN_WEB_SOURCE_MAP = {
    "news.metal.com": "metal.news",
    "data-pro.metal.com": "metal.data-pro",
    "www.metal.com": "metal.www",
    "user.metal.com": "metal.user",
    "history.metal.com": "metal.price",
    "publications.metal.com": "metal.publications",
    "buy.metal.com": "metal.buy",
    "car.metal.com": "metal.car",
    "multilingual.metal.com": "metal.multi",
};
export const SIGN_IN_EN_H5_SOURCE_MAP = {
    "news.metal.com": "metal.h5.news",
    "www.metal.com": "metal.h5.www",
    "user.metal.com": "metal.h5.user",
    "publications.metal.com": "metal.h5.publications",
    "buy.metal.com": "metal.h5.buy",
    "price-m.metal.com": "metal.h5.price",
    "www-m.metal.com": "metal.h5.www",
};
//# sourceMappingURL=const.js.map